import { TextField, InputAdornment, IconButton, Button } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import SecuritiesDatePicker from '../../components/Shared/SecuritiesDatePicker';
import { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

interface OnBehalfOfUserSelectorProps {
	onBehalfOfUserName: string;
	handleClear: () => void;
	showUserPicker: () => void;
	selectedDate?: Dayjs | null;
	onDateChange?: (date: Dayjs | null) => void;
}

export default function OnBehalfOfUserSelector({
	onBehalfOfUserName,
	handleClear,
	showUserPicker,
	selectedDate,
	onDateChange
}: OnBehalfOfUserSelectorProps) {

	const handleDateChange = (newDate: Dayjs | null) => {
		if (newDate) {
			newDate = newDate.startOf('day');

			// If the new date is in the future relative to today, clear selection to force user to correct.
			if (newDate.isAfter(dayjs().startOf('day'))) {
				if (onDateChange) {
					onDateChange(null); // clears previously valid date so Continue button disables
				}
				return;
			}
		}

		if (onDateChange) {
			onDateChange(newDate);
		}
	};

	return (
		<div>
			<div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
				<label style={{ minWidth: '100px', textAlign: 'left' }}>On behalf of *</label>
				<TextField
					style={{
						border: '1px solid #707070',
						borderRadius: '4px',
						width: '300px',
					}}
					InputProps={{
						readOnly: true,
						endAdornment: onBehalfOfUserName && (
							<InputAdornment position="end">
								<IconButton onClick={handleClear} edge="end">
									<ClearIcon />
								</IconButton>
							</InputAdornment>
						)
					}}
					size="small"
					value={onBehalfOfUserName}
					required
				/>
				<Button onClick={showUserPicker}>
					<SearchIcon />
				</Button>
			</div>
			{onDateChange && (
				<div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
					<label style={{ 
						minWidth: '100px', 
						textAlign: 'left'
					}}>
						Select the date that Epiq received the submission
					</label>
					<SecuritiesDatePicker
						label="Postmark Date"
						value={selectedDate || null}
						onChange={handleDateChange}
						maxDate={dayjs()}
						disableFuture
						views={['year', 'month', 'day']}
						InputLabelProps={{ shrink: true }}
						style={{ minWidth: '200px' }}
					/>
				</div>
			)}
		</div>
	);
}
